/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'ทีม Workplace Experience ของเราจะดำเนินการตามคำขอของขวัญ ✨',
  'team-central.give-jira-kudos.created.title.flag': 'สร้างคำชื่นชมแล้ว',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'เราไม่สามารถสร้างคำชื่นชมหรือส่งของขวัญของคุณได้ ลองสร้างคำสั่งแยกต่างหากที่ <a>go/kudos</a>',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'เกิดข้อผิดพลาดบางอย่าง',
  'team-central.give-kudos.button': 'แสดงความชื่นชม',
  'team-central.give-kudos.close-button.label': 'ปิดหน้าจอ',
  'team-central.give-kudos.confirm-close.title': 'ยืนยันการปิด',
  'team-central.give-kudos.created.description.flag': 'ส่งคำชื่นชมของคุณแล้ว <a>ดูคำชื่นชม</a>',
  'team-central.give-kudos.created.title.flag': 'สร้างคำชื่นชมแล้ว',
  'team-central.give-kudos.creation.failed.description.flag': 'เราไม่สามารถสร้างคำชื่นชมของคุณได้',
  'team-central.give-kudos.creation.failed.title.flag': 'เกิดข้อผิดพลาดบางอย่าง',
  'team-central.give-kudos.error-icon.label': 'ข้อผิดพลาด',
  'team-central.give-kudos.success-icon.label': 'สำเร็จ',
  'team-central.give-kudos.unsaved.warning': 'การเปลี่ยนแปลงที่คุณทำไว้จะไม่ได้รับการบันทึก',
  'team-central.give-kudos.unsaved.warning.cancel': 'ยกเลิก',
  'team-central.give-kudos.unsaved.warning.close': 'ปิด'
};